module.exports = __webpack_public_path__ + "img/giftbox.b344dbe.webp";